import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../../shared-modules/login/login.service';
import { StudentService } from '../../../shared-components/student/student.service';
import { YearService } from '../../../shared-components/year/year.service';
import { System } from '../../../shared-components/System';
import { Router } from '@angular/router';
import { SendEmailService } from '../../../shared-modules/send-email/send-email.service';
import { CourseDescriptionDialogComponent } from '../../../shared-components/course-description-dialog/course-description-dialog.component';
import { ProfileViewerDialogComponent } from '../../../shared-components/profile-viewer-dialog/profile-viewer-dialog.component';
import { GradebookV9Service } from '../../../classroom360/gradebook/v9/gradebook-v9.service';
import * as moment from 'moment';
import { AssignmentService } from '../../assignment/assignment.service';
import { CalendarService } from '../calendar.service';
import { UserService } from '../../../shared-components/user/user.service';


@Component({
    selector: 'app-calendar-event-modal',
    templateUrl: './calendar-event-modal.component.html',
    styleUrls: ['./calendar-event-modal.component.css']
})
export class CalendarEventModalComponent implements OnInit {
    isV10: boolean;
    event: any;
    assignments: any[];
    attendanceDetails: any;
    eventType: any;
    eventDetails: any;
    courseInfo: any;
    dataBucketId: number;
    constructor(
        private gradebookV9Service: GradebookV9Service,
        private assignmentService: AssignmentService,
        private sendEmailService: SendEmailService,
        private calendarService: CalendarService,
        private router: Router,
        private studentService: StudentService,
        private yearService: YearService,
        private loginService: LoginService,
        private userService: UserService,
        private dialogRef: MatDialogRef<CalendarEventModalComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) {
        this.event = data;
        this.isV10 = this.loginService.LoginSettings.V10;
        this.eventType = this.event.meta.eventType;
        this.eventDetails = this.event.meta.event;
        this.assignments = this.event.meta.event.Assignments;
        this.courseInfo = this.event.meta.courseInfo;
        this.dataBucketId = this.event.meta.event.DataBucket_ID;
        this.getTerms();
        if (this.isV10) {
            this.courseInfo.SiteSectionId = this.courseInfo.Id;
        } else {
            this.getV9Attachments();
        }
    }

    ngOnInit() {
        if (this.eventType == 'dailyScheduleEvent') {
            this.studentService.getStudentAttendance(this.studentService.selectedStudent.Id, this.yearService.student360Year.Id, true).subscribe(data => {
                // pull out the date of interest
                const attendanceEvent = data.find(a => a.AttendanceDate == this.eventDetails.Date);
                if (!!attendanceEvent) {
                    this.attendanceDetails = attendanceEvent.AttendanceDetails.find(a => a.SiteSectionId == this.event.id);
                }
            });
        }
    }

    getTerms() {
         if (this.dataBucketId != undefined) {
             this.calendarService.getTermsForCourses(this.dataBucketId, this.isV10 ? this.yearService.student360Year.Id : this.studentService.studentEnrollment.SiteYearId).subscribe(response => {
                 if (response) {
                     this.courseInfo.CourseTerms = response;
                 }
             });
         }
    }

    getV9Attachments() {
        this.assignments.forEach(assignment => {
            this.gradebookV9Service.getGradebookV9Attachments(assignment.AssignmentId).subscribe(results => {
                assignment.Attachments = results;
                assignment.Attachment = results.length;
            });
        });
    }

    attendanceStatus() {
        if (this.attendanceDetails == undefined || this.attendanceDetails == null) {
            return 'Present';
        } else {
            if (this.attendanceDetails.AttendanceCode == '') {
                return 'Present';
            } else {
                return (this.attendanceDetails.AttendanceCode + ' - ' + this.attendanceDetails.AttendanceCodeDescription);
            }
        }
    }

    attachmentDescription(attachment) {
        if (!!attachment.Description) {
            return ('- ' + attachment.Description);
        }
    }

    attachmentClick(attachment) {
        System.saveFile(attachment.DocumentBase64, attachment.DocumentType, attachment.FileName);
    }

    route(route: string) {
        // Route to the appropriate location then close the modal
        switch (route) {
            case 'Assignments':
                this.assignmentService.selectedCourse = this.courseInfo;
                this.assignmentService.selectedSectionId = this.courseInfo.SiteSectionId;
                this.assignmentService.selectedGP = undefined;
                this.assignmentService.preventTabSwitch = true;
                if (!this.userService.studentInformationView)
                    this.router.navigateByUrl('/student360/assignments');
                else
                    this.userService.updateStudentViewRoute('/student360/assignments');
                this.dialogRef.close();
                break;
            case 'Attendance':
                if (!this.userService.studentInformationView)
                    this.router.navigateByUrl('/student360/attendance');
                else
                    this.userService.updateStudentViewRoute('/student360/attendance');
                this.dialogRef.close();
                break;
            case 'Grades':
                if (!this.userService.studentInformationView)
                    this.router.navigateByUrl('/student360/reportCardGrades');
                else
                    this.userService.updateStudentViewRoute('/student360/reportCardGrades');
                this.dialogRef.close();
                break;
            case 'Email Teacher':
                this.sendEmailService.teacherName = this.courseInfo.TeacherName;
                this.sendEmailService.teacherEmailAddress = this.courseInfo.TeacherEmail;
                if (!this.userService.studentInformationView)
                    this.router.navigateByUrl('/student360/sendEmail');
                else
                    this.userService.updateStudentViewRoute('/student360/sendEmail');
                this.dialogRef.close();
                break;
            case 'Course Description':
                this.dialog.open(CourseDescriptionDialogComponent, {
                    data: {
                        course: this.courseInfo.Course,
                        courseSection: this.courseInfo.SubjectCode + '-' + this.courseInfo.Section,
                        teacherName: this.courseInfo.TeacherName,
                        schoolName: this.courseInfo.SchoolName,
                        curriculum: this.courseInfo.Curriculum,
                        description: this.courseInfo.Description
                    },
                    disableClose: true
                });
                break;
            case 'Class Information':
                this.dialog.open(ProfileViewerDialogComponent, {
                    data: {
                        courseSSEC_ID: this.courseInfo.Id,
                        courseName: this.courseInfo.Course,
                        courseSection: this.courseInfo.SubjectCode + '-' + this.courseInfo.Section,
                        teacherName: this.courseInfo.TeacherName,
                        school: this.courseInfo.SchoolName,
                        profiles: this.courseInfo.CourseProfile,
                        showTeacherProfileLink: false
                    },
                    disableClose: true
                });
                break;
            case 'Teacher Profile':
                this.dialog.open(ProfileViewerDialogComponent, {
                    data: {
                        teacherId: this.courseInfo.TeacherMemId,
                        teacherName: this.courseInfo.TeacherName,
                        school: this.courseInfo.SchoolName,
                        profiles: this.courseInfo.TeacherProfile
                    },
                    disableClose: true
                });
                break;
        }
    }

    closeClick() {
        this.dialogRef.close();
    }

    assignedDate(date: any) {
        if (date == '0001-01-01T00:00:00') {
            return '';
        } else {
            // Format the date and return it
            return moment(date, 'YYYY-MM-DDThh:mm:ss').format('MM/DD/YY');
        }
    }
}
